import React from "react"
import About from "../components/by-a-student"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"
import config from "../lib/config"

export default function Example() {
  return (
    <Layout>
      <Helmet>
        <title>About &mdash; {config.siteTitle}</title>
      </Helmet>
      <About
        bgClassName="bg-white"
        headerText={`${config.siteTitle}: Emergency Response For Schools`}
      />
    </Layout>
  )
}
